import React, { useEffect, useState } from 'react';
import { Input } from '../../../../../../../../../components/Common/UI/Input';
import { Button } from '../../../../../../../../../components/Common/UI/Button';
import Icons from '../../../../../../../../../components/Common/Icons/Icons';
import ModuleEditBlock from '../Block';

function TemplateBlock() {
  const [templateName, setTemplateName] = useState<string>('');
  const [isError, setIsError] = useState<boolean>(false);

  useEffect(() => {
    if (templateName.length) {
      setIsError(false);
    }
  }, [templateName]);

  return (
    <ModuleEditBlock title="Template" subTitle="Save these criteria as a new template">
      <>
        <div className="flex gap-[10px] items-center">
          <Input
            placeholder="Template Name"
            className="min-w-[325px]"
            value={templateName}
            onChange={e => setTemplateName(e.target.value)}
            error={isError ? 'Template name is required' : ''}
          />
          <Button
            className="hover:opacity-85 bg-white p-0 hover:bg-white"
            onClick={() => {
              if (!templateName.length) {
                setIsError(true);
              }
            }}
          >
            <Icons.SaveFilled className="[&_path]:fill-addition5" />
            <span className="text-addition5">Save</span>
          </Button>
        </div>
        <div className="mt-[5px] text-sm text-addition1-50 font-medium">Max 75 characters allowed</div>
      </>
    </ModuleEditBlock>
  );
}

export default TemplateBlock;
